export default (texto) => {
	if (texto) return texto
	return 'EM RASCUNHO'
}
